import { z } from "zod";

import { domainUserSchema } from "../domain/schemas";
import { AdminRole } from "./roles";

export const adminRoleSchema = z.nativeEnum(AdminRole);
export type AdminRoleValue = z.infer<typeof adminRoleSchema>;

export const adminIdentitySchema = z.object({
  user: domainUserSchema,
  role: adminRoleSchema,
});
export type AdminIdentity = z.infer<typeof adminIdentitySchema>;

export const adminRecordSchema = z.object({
  id: z.string(),
  email: z.string(),
  userId: z.string().nullable(),
  role: adminRoleSchema,
  note: z.string().nullable(),
  createdAt: z.string(),
});
export type AdminRecord = z.infer<typeof adminRecordSchema>;

export const signupPointSchema = z.object({
  date: z.string(),
  count: z.number(),
});
export type SignupPoint = z.infer<typeof signupPointSchema>;

export const adminDashboardStatsSchema = z.object({
  organizationCount: z.number(),
  adminCount: z.number(),
  signups: z.array(signupPointSchema),
  recentUsers: z.array(domainUserSchema),
});
export type AdminDashboardStats = z.infer<typeof adminDashboardStatsSchema>;
